// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-lobby {
  width: 100%;
  padding-bottom: 20px;
}

.lotus-casino-lobby-group {
  width: 100%;
  margin-bottom: 24px;
}

.lotus-casino-lobby-group__title {
  height: 42px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  text-transform: capitalize;
  padding: 0 4px;
  margin-bottom: 6px;
}

.lotus-casino-lobby-group__title-icon {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
  color: #67af7e;
}

.lotus-casino-lobby-group__title-icon.icon-fire::before {
  color: #ff8c42;
}

/* 5-column grid for lobby rows, favorites, etc. */
.lotus-casino-lobby-group__grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px 12px;
  width: 100%;
  overflow: visible;
}

.lotus-casino-lobby-group__grid > .lotus-casino-card--compact {
  width: auto;
  max-width: 100%;
  min-width: 0;
}

.lotus-casino-lobby-skeleton {
  width: 100%;
  aspect-ratio: 245 / 153;
  border-radius: 8px;
  background: linear-gradient(90deg, #1a1a1a 25%, #252525 50%, #1a1a1a 75%);
  background-size: 200% 100%;
  animation: lotus-casino-shimmer 1.2s infinite;
}

.lotus-casino-lobby-group__more-card {
  margin: 6px;
  width: calc(100% - 12px);
  aspect-ratio: 233 / 141;
  border-radius: 8px;
  background: #262626;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
  box-sizing: border-box;
}

.lotus-casino-lobby-group__more-card:hover {
  background: #2e2e2e;
}

.lotus-casino-lobby-group__more-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-family: "Lato", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 23px;
  color: #e0e0e0;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.lotus-casino-lobby-group__more-inner .icon-angle-right {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #e0e0e0;
  margin-left: 5px;
}

.lotus-casino-card--compact {
  width: auto;
  max-width: 100%;
  min-width: 0;
}

.lotus-casino-card--compact .lotus-casino-card__container {
  width: 100%;
}

.lotus-casino-card--compact .lotus-casino-card__banner {
  width: 100%;
  aspect-ratio: 245 / 153;
  height: auto;
  max-height: none;
}

.lotus-casino-card--compact .lotus-casino-card__banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lotus-casino-card--compact .lotus-casino-card__play {
  min-width: 90px;
  height: 32px;
  font-size: 12px;
}

@keyframes lotus-casino-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 900px) {
  .lotus-casino-lobby-group__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* Mobile casino (≤1119): always 3 columns — never drop to 2 */
@media (max-width: 1119px) {
  .lotus-casino-lobby-group__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px 8px;
    padding: 0 8px;
    box-sizing: border-box;
  }

  .lotus-casino-lobby {
    padding-bottom: 12px;
  }

  /* No dark “card” group backgrounds — flat like Trending Now */
  .lotus-casino-lobby.colorful-container > .lotus-casino-lobby-group,
  .lotus-casino-tab-games--grouped > .lotus-casino-lobby-group {
    position: relative;
    margin-bottom: 8px;
    padding: 8px 0 10px;
    border-radius: 0;
    background: transparent;
  }

  .lotus-casino-lobby.colorful-container > .lotus-casino-lobby-group:nth-child(odd),
  .lotus-casino-tab-games--grouped > .lotus-casino-lobby-group:nth-child(odd) {
    background: transparent;
  }

  .lotus-casino-lobby-group__title {
    height: auto;
    min-height: 34px;
    padding: 5px 6px;
    margin-bottom: 6px;
    font-size: 18px;
    gap: 6px;
  }

  .lotus-casino-lobby-group__title-icon {
    font-size: 24px;
  }

  /* More Games: absolute, vertically centered on title row */
  .lotus-casino-lobby-group.is-mobile-lobby-row {
    position: relative;
  }

  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-card {
    position: absolute;
    top: 8px;
    right: 10px;
    height: 34px;
    width: auto;
    margin: 0;
    aspect-ratio: auto;
    background: transparent;
    border-radius: 8px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-card:hover {
    background: transparent;
  }

  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-inner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    color: #e0e0e0;
    white-space: nowrap;
  }

  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-inner .icon-angle-right {
    font-size: 12px;
    width: 12px;
    height: 12px;
    margin-left: 5px;
  }

  .lotus-casino-card--compact .lotus-casino-card__banner {
    aspect-ratio: 109.33 / 68.33;
    border-radius: 8px;
  }

  .lotus-casino-card--compact .lotus-casino-card__banner img {
    border-radius: 8px;
  }
}

@media (max-width: 560px) {
  /* Keep 3 columns on phone — override previous 2-col rule */
  .lotus-casino-lobby-group__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoLobby/LotusCasinoLobby.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,gDAAgD;IAChD,aAAa;IACb,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA,8DAA8D;EAC9D;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA,2DAA2D;EAC3D;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,2DAA2D;EAC3D;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".lotus-casino-lobby {\n  width: 100%;\n  padding-bottom: 20px;\n}\n\n.lotus-casino-lobby-group {\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.lotus-casino-lobby-group__title {\n  height: 42px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: \"Lato\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: capitalize;\n  padding: 0 4px;\n  margin-bottom: 6px;\n}\n\n.lotus-casino-lobby-group__title-icon {\n  font-size: 20px;\n  line-height: 1;\n  flex-shrink: 0;\n  color: #67af7e;\n}\n\n.lotus-casino-lobby-group__title-icon.icon-fire::before {\n  color: #ff8c42;\n}\n\n/* 5-column grid for lobby rows, favorites, etc. */\n.lotus-casino-lobby-group__grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 16px 12px;\n  width: 100%;\n  overflow: visible;\n}\n\n.lotus-casino-lobby-group__grid > .lotus-casino-card--compact {\n  width: auto;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.lotus-casino-lobby-skeleton {\n  width: 100%;\n  aspect-ratio: 245 / 153;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #1a1a1a 25%, #252525 50%, #1a1a1a 75%);\n  background-size: 200% 100%;\n  animation: lotus-casino-shimmer 1.2s infinite;\n}\n\n.lotus-casino-lobby-group__more-card {\n  margin: 6px;\n  width: calc(100% - 12px);\n  aspect-ratio: 233 / 141;\n  border-radius: 8px;\n  background: #262626;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  box-sizing: border-box;\n}\n\n.lotus-casino-lobby-group__more-card:hover {\n  background: #2e2e2e;\n}\n\n.lotus-casino-lobby-group__more-inner {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  font-family: \"Lato\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 23px;\n  color: #e0e0e0;\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.lotus-casino-lobby-group__more-inner .icon-angle-right {\n  flex-shrink: 0;\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  color: #e0e0e0;\n  margin-left: 5px;\n}\n\n.lotus-casino-card--compact {\n  width: auto;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.lotus-casino-card--compact .lotus-casino-card__container {\n  width: 100%;\n}\n\n.lotus-casino-card--compact .lotus-casino-card__banner {\n  width: 100%;\n  aspect-ratio: 245 / 153;\n  height: auto;\n  max-height: none;\n}\n\n.lotus-casino-card--compact .lotus-casino-card__banner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lotus-casino-card--compact .lotus-casino-card__play {\n  min-width: 90px;\n  height: 32px;\n  font-size: 12px;\n}\n\n@keyframes lotus-casino-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n@media (max-width: 900px) {\n  .lotus-casino-lobby-group__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* Mobile casino (≤1119): always 3 columns — never drop to 2 */\n@media (max-width: 1119px) {\n  .lotus-casino-lobby-group__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px 8px;\n    padding: 0 8px;\n    box-sizing: border-box;\n  }\n\n  .lotus-casino-lobby {\n    padding-bottom: 12px;\n  }\n\n  /* No dark “card” group backgrounds — flat like Trending Now */\n  .lotus-casino-lobby.colorful-container > .lotus-casino-lobby-group,\n  .lotus-casino-tab-games--grouped > .lotus-casino-lobby-group {\n    position: relative;\n    margin-bottom: 8px;\n    padding: 8px 0 10px;\n    border-radius: 0;\n    background: transparent;\n  }\n\n  .lotus-casino-lobby.colorful-container > .lotus-casino-lobby-group:nth-child(odd),\n  .lotus-casino-tab-games--grouped > .lotus-casino-lobby-group:nth-child(odd) {\n    background: transparent;\n  }\n\n  .lotus-casino-lobby-group__title {\n    height: auto;\n    min-height: 34px;\n    padding: 5px 6px;\n    margin-bottom: 6px;\n    font-size: 18px;\n    gap: 6px;\n  }\n\n  .lotus-casino-lobby-group__title-icon {\n    font-size: 24px;\n  }\n\n  /* More Games: absolute, vertically centered on title row */\n  .lotus-casino-lobby-group.is-mobile-lobby-row {\n    position: relative;\n  }\n\n  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-card {\n    position: absolute;\n    top: 8px;\n    right: 10px;\n    height: 34px;\n    width: auto;\n    margin: 0;\n    aspect-ratio: auto;\n    background: transparent;\n    border-radius: 8px;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-card:hover {\n    background: transparent;\n  }\n\n  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-inner {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n    color: #e0e0e0;\n    white-space: nowrap;\n  }\n\n  .lotus-casino-lobby-group.is-mobile-lobby-row .lotus-casino-lobby-group__more-inner .icon-angle-right {\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n    margin-left: 5px;\n  }\n\n  .lotus-casino-card--compact .lotus-casino-card__banner {\n    aspect-ratio: 109.33 / 68.33;\n    border-radius: 8px;\n  }\n\n  .lotus-casino-card--compact .lotus-casino-card__banner img {\n    border-radius: 8px;\n  }\n}\n\n@media (max-width: 560px) {\n  /* Keep 3 columns on phone — override previous 2-col rule */\n  .lotus-casino-lobby-group__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
